import {FC} from 'react';

import i18n from 'i18next';

import {DeliveryIconRibbon} from 'assets/icons/deliveryIconRibbon';
import {ProductType} from 'types';

import {IconBox, StyledBasketProductImage, StyledRibbons} from './styles';
import {AvailableLanguageTypes} from '../../constants';

export interface BasketProductImageProps {
  src: string;
  productType?: ProductType;
  isBulky?: boolean;
}

export const BasketProductImage: FC<BasketProductImageProps> = ({src, productType, isBulky}) => {
  const language = (i18n?.language as AvailableLanguageTypes) || AvailableLanguageTypes.THAI;
  const is1p = productType === '1p';
  const is3P = productType === ProductType.PRODUCT_3P;
  return (
    <StyledBasketProductImage>
      {!isBulky && !is1p && !is3P && (
        <StyledRibbons>
          <IconBox width={18} height={22}>
            <DeliveryIconRibbon language={language} type={productType} />
          </IconBox>
        </StyledRibbons>
      )}
      <img height={60} width={60} src={src} alt="product image" />
    </StyledBasketProductImage>
  );
};

BasketProductImage.displayName = 'BasketProductImage';
